// extracted by mini-css-extract-plugin
module.exports = {"progressSpinner":"ProgressSpinner_progressSpinner__nPi0c","spinner":"ProgressSpinner_spinner__uIUMN"};